<template>
  <div id="policy-terms-and-conditions" class="callout" data-test-policy-terms-and-conditions>
    <h3 v-html="modelValue.Headline" />
    <p v-html="modelValue.Description" />
    <ul class="no-bullet">
      <li v-for="(terms, index) in modelValue.TermsAndConditions" :key="index">
        <a :href="terms.LinkUrl" class="link-icon-left" target="_blank">
          <span class="icon-download" /><u>{{ terms.LinkText }}</u>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TermsAndConditions',
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
